import { render, staticRenderFns } from "./EmailCrudConfirm.vue?vue&type=template&id=fabeb20e"
import script from "./EmailCrudConfirm.vue?vue&type=script&lang=js"
export * from "./EmailCrudConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports